import BlogBanner from './BlogBanner';
export default BlogBanner;
